import React from 'react';
import ReactDOM from 'react-dom';
import { CloseIcon } from '../../icons/Close';
import { usePopup } from '../../hooks/usePopup';
import './PopupPlan.scss';
import Plans from '../Plans/Plans';

export function PopupPlan({
  title,
  planSet, // free | standard-premium | premium
  redirectionObjectTitle,
  closeModal,
  userAccess = 'free'
}) {

  usePopup(closeModal);


  return ReactDOM.createPortal(
    <div className="PopupPlan">
      <button className="PopupPlan__close" onClick={() => {
        // actid=7
        window.analytics?.track("button:click", {
          "button_name": "close",
          "parent_object_title": redirectionObjectTitle,
          "title": title,
        });
        closeModal();
      }}>
        <CloseIcon />
      </button>
    <Plans userAccess={userAccess} analyticsData={{redirectionObjectTitle, title}} planSet={planSet}/>
    </div>,
    document.getElementById('pc-popup-portal'));
}
